import { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Stack,
  Typography
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import {
  customersApi,
  type CustomerSummary
} from '@/api/modules/customers';
import { PaginatedList } from '@/components/data/PaginatedList';
import { paths } from '@/router/paths';

export function CustomerListPage() {
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const query = useQuery({
    queryKey: ['customers', 'summaries', page],
    queryFn: () => customersApi.summaries(page, 20)
  });

  return (
    <Box>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ sm: 'center' }}
        spacing={1}
        sx={{ mb: 3 }}
      >
        <Box>
          <Typography variant="h1" gutterBottom>
            Customers
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Master data — per-customer rate is used to price EV battery quotations.
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate(paths.customerCreate)}
        >
          New customer
        </Button>
      </Stack>

      <PaginatedList<CustomerSummary>
        page={query.data}
        isLoading={query.isLoading}
        error={query.error}
        onPageChange={setPage}
        renderItem={(c) => (
          <Card variant="outlined">
            <CardActionArea
              onClick={() => navigate(paths.customerDetail.replace(':id', c.id))}
            >
              <CardContent>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={1}
                  alignItems={{ sm: 'center' }}
                  justifyContent="space-between"
                >
                  <Box>
                    <Typography variant="h3">{c.name}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {c.code}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Rate: {c.currency} {c.perWhRate} / Wh
                    </Typography>
                  </Box>
                  <Chip
                    size="small"
                    label={c.active ? 'ACTIVE' : 'INACTIVE'}
                    color={c.active ? 'success' : 'default'}
                  />
                </Stack>
              </CardContent>
            </CardActionArea>
          </Card>
        )}
        emptyMessage="No customers yet. Click New customer to add one."
      />
    </Box>
  );
}
